var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-container" },
    [
      _c(
        "el-card",
        {
          staticClass: "statistics-cards-container",
          attrs: { shadow: "hover" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-card project-card" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "el-icon-s-order" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c(
                      "div",
                      { staticClass: "stat-value" },
                      [
                        _c("count-to", {
                          attrs: {
                            "start-val": 0,
                            "end-val":
                              _vm.statistics.projectNum || _vm.total || 0,
                            duration: 2000,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("总项目数"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-card amount-card" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "el-icon-money" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c(
                      "div",
                      { staticClass: "stat-value" },
                      [
                        _vm._v("¥\n              "),
                        _c("count-to", {
                          attrs: {
                            "start-val": 0,
                            "end-val": Number(
                              _vm.statistics.projectTotalAmount ||
                                _vm.totalBeans ||
                                0
                            ),
                            duration: 2000,
                            decimals: 2,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("涉及福豆数"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-card balance-card" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "el-icon-wallet" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c(
                      "div",
                      { staticClass: "stat-value" },
                      [
                        _vm._v("¥\n              "),
                        _c("count-to", {
                          attrs: {
                            "start-val": 0,
                            "end-val": Number(
                              _vm.statistics.projectBalanceAmount ||
                                _vm.availableBeans ||
                                0
                            ),
                            duration: 2000,
                            decimals: 2,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("剩余可用福豆数"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-card count-card" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "el-icon-bank-card" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c(
                      "div",
                      { staticClass: "stat-value" },
                      [
                        _c("count-to", {
                          attrs: {
                            "start-val": 0,
                            "end-val":
                              _vm.statistics.projectCardNum ||
                              _vm.totalCards ||
                              0,
                            duration: 2000,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("发放卡片总数"),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "divBox" },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c(
                    "div",
                    { staticClass: "filter-header" },
                    [
                      _c("span", { staticClass: "filter-title" }, [
                        _vm._v("筛选条件"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-toggle",
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              _vm.isFilterCollapsed = !_vm.isFilterCollapsed
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.isFilterCollapsed ? "展开筛选" : "收起筛选"
                              ) +
                              "\n            "
                          ),
                          _c("i", {
                            class: [
                              _vm.isFilterCollapsed
                                ? "el-icon-arrow-down"
                                : "el-icon-arrow-up",
                            ],
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "filter-container",
                      class: { "is-collapsed": _vm.isFilterCollapsed },
                    },
                    [
                      _c(
                        "el-form",
                        { attrs: { inline: "", size: "small" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "项目名称" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  placeholder: "请输入项目名称",
                                  size: "small",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.listPram.projectName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listPram, "projectName", $$v)
                                  },
                                  expression: "listPram.projectName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "关联id" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  placeholder: "请输入关联id",
                                  size: "small",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.listPram.relativeId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listPram, "relativeId", $$v)
                                  },
                                  expression: "listPram.relativeId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "项目类型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择项目类型",
                                    clearable: "",
                                  },
                                  on: {
                                    "visible-change": function (val) {
                                      return val && _vm.loadProjectTypeOptions()
                                    },
                                  },
                                  model: {
                                    value: _vm.listPram.projectType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "projectType", $$v)
                                    },
                                    expression: "listPram.projectType",
                                  },
                                },
                                _vm._l(_vm.projectTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "项目状态" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择项目状态",
                                    clearable: "",
                                  },
                                  on: {
                                    "visible-change": function (val) {
                                      return (
                                        val && _vm.loadProjectStatusOptions()
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.listPram.projectStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.listPram,
                                        "projectStatus",
                                        $$v
                                      )
                                    },
                                    expression: "listPram.projectStatus",
                                  },
                                },
                                _vm._l(
                                  _vm.projectStatusOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "对应卡片" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择对应卡片",
                                    clearable: "",
                                  },
                                  on: {
                                    "visible-change": function (val) {
                                      return val && _vm.loadCardOptions()
                                    },
                                  },
                                  model: {
                                    value: _vm.listPram.cardId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "cardId", $$v)
                                    },
                                    expression: "listPram.cardId",
                                  },
                                },
                                _vm._l(_vm.cardOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "归属客户" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择归属客户",
                                    clearable: "",
                                  },
                                  on: {
                                    "visible-change": function (val) {
                                      return val && _vm.loadCustomerOptions()
                                    },
                                  },
                                  model: {
                                    value: _vm.listPram.customerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "customerId", $$v)
                                    },
                                    expression: "listPram.customerId",
                                  },
                                },
                                _vm._l(_vm.customerOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "发放小程序" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择发放小程序",
                                    clearable: "",
                                  },
                                  on: {
                                    "visible-change": function (val) {
                                      return val && _vm.loadMiniappOptions()
                                    },
                                  },
                                  model: {
                                    value: _vm.listPram.miniappId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "miniappId", $$v)
                                    },
                                    expression: "listPram.miniappId",
                                  },
                                },
                                _vm._l(_vm.miniappOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "内部备注" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  placeholder: "请输入内部备注",
                                  size: "small",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.listPram.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listPram, "remark", $$v)
                                  },
                                  expression: "listPram.remark",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "发放时间" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "value-format": "yyyy-MM-dd",
                                },
                                on: { change: _vm.handleDateChange },
                                model: {
                                  value: _vm.dateRange,
                                  callback: function ($$v) {
                                    _vm.dateRange = $$v
                                  },
                                  expression: "dateRange",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-search",
                                  },
                                  on: { click: _vm.handerSearch },
                                },
                                [_vm._v("搜索")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { icon: "el-icon-refresh" },
                                  on: { click: _vm.resetSearch },
                                },
                                [_vm._v("重置")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    icon: "el-icon-download",
                                  },
                                  on: { click: _vm.handleExport },
                                },
                                [_vm._v("导出")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "info",
                                    icon: "el-icon-refresh-right",
                                    title: "刷新数据 (Ctrl+R)",
                                  },
                                  on: { click: _vm.refreshData },
                                },
                                [_vm._v("刷新")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "table",
                  attrs: {
                    data: _vm.tableData,
                    "highlight-current-row": "",
                    "header-cell-style": { fontWeight: "bold" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "ID",
                      "min-width": "80",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "projectType",
                      label: "项目类型",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getProjectTypeName(scope.row.projectType)
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "projectName",
                      label: "项目名称",
                      "min-width": "150",
                      align: "center",
                      "show-overflow-tooltip": true,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "relativeId",
                      label: "关联ID",
                      "min-width": "120",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "relatedNumber",
                      label: "关联编号",
                      "min-width": "120",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cardName",
                      label: "福卡",
                      "min-width": "120",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      label: "项目状态",
                      "min-width": "140",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getStatusType(scope.row.status),
                                  size: "small",
                                },
                              },
                              [
                                _vm.getStatusName(scope.row.status) === "已发放"
                                  ? _c("i", {
                                      staticClass: "el-icon-circle-check",
                                    })
                                  : _vm.getStatusName(scope.row.status) ===
                                    "已生成订单"
                                  ? _c("i", { staticClass: "el-icon-tickets" })
                                  : _vm.getStatusName(scope.row.status) ===
                                    "待发放"
                                  ? _c("i", { staticClass: "el-icon-time" })
                                  : _vm.getStatusName(scope.row.status) ===
                                      "作废" ||
                                    _vm.getStatusName(scope.row.status) ===
                                      "已删除"
                                  ? _c("i", { staticClass: "el-icon-warning" })
                                  : _vm.getStatusName(scope.row.status) ===
                                    "卡密生成中"
                                  ? _c("i", { staticClass: "el-icon-loading" })
                                  : _vm.getStatusName(scope.row.status) ===
                                    "已确认"
                                  ? _c("i", {
                                      staticClass: "el-icon-document-checked",
                                    })
                                  : _vm.getStatusName(scope.row.status) ===
                                    "已下单"
                                  ? _c("i", {
                                      staticClass: "el-icon-shopping-cart-full",
                                    })
                                  : _c("i", { staticClass: "el-icon-info" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getStatusName(scope.row.status)
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remark",
                      label: "内部备注",
                      "min-width": "150",
                      align: "center",
                      "show-overflow-tooltip": true,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalAmount",
                      label: "总金额",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatMoney(scope.row.budget)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "availableAmount",
                      label: "可用金额",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatMoney(
                                    scope.row.availableAmount || 0
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cardCount",
                      label: "卡片数量",
                      "min-width": "100",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "miniappName",
                      label: "发放小程序",
                      "min-width": "120",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerName",
                      label: "归属客户",
                      "min-width": "150",
                      align: "center",
                      "show-overflow-tooltip": true,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "issueTime",
                      label: "发放时间",
                      "min-width": "150",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "validTime",
                      label: "有效期",
                      "min-width": "180",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.validTime) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "创建时间",
                      "min-width": "150",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      "min-width": "160",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看详情")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCardDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("卡片明细")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("template", { slot: "empty" }, [
                    _c(
                      "div",
                      { staticClass: "empty-state" },
                      [
                        _c("i", { staticClass: "el-icon-document" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("暂无项目数据")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.resetSearch },
                          },
                          [_vm._v("清除筛选条件")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.listPram.page,
                  "page-sizes": [20, 40, 60, 80, 100],
                  "page-size": _vm.listPram.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("ProjectDetail", {
            ref: "projectDetailRef",
            on: { refresh: _vm.handlerGetListData },
          }),
          _vm._v(" "),
          _c("CardDetail", { ref: "cardDetailRef" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }